import React from 'react';
import cn from 'classnames';
import Animation from '@dealroadshow/uikit-animation';
import styles from './introSmall.module.scss';

interface IProps {
  title: string,
  description?: React.ReactNode,
  className: string,
  classNameDescription?: string,
  dataTest?: string,
}

const Intro = ({ title, description, className, classNameDescription, dataTest = 'introSection' }: IProps) => (
  <div className={ cn(styles.intro, className) } data-test={ dataTest }>
    <div className={ styles.introContainer }>
      <h1 className={ styles.introTitle }>
        { title }
      </h1>
      { description && (
        <div className={ cn(styles.introDescription, classNameDescription) }>
          { description }
        </div>
      ) }
    </div>
    <Animation />
  </div>
);

export default Intro;
